// src/utils/token.js
import Cookies from 'js-cookie'; // Make sure to install: npm install js-cookie

// Token storage (using admin_token as per your existing code)
export const setToken = (token) => {
  localStorage.setItem("admin_token", token);
  // Also store in cookie with 7 days expiry
  Cookies.set('admin_token', token, { expires: 7, secure: true, sameSite: 'strict' });
};

export const getToken = () => {
  return localStorage.getItem("admin_token") || Cookies.get('admin_token');
};

export const clearToken = () => {
  localStorage.removeItem("admin_token");
  Cookies.remove('admin_token');
  // Also clear user data when logging out
  clearUserData();
};

// User data storage functions
export const setUserData = (userData) => {
  localStorage.setItem('admin_user', JSON.stringify(userData));
  Cookies.set('admin_user', JSON.stringify(userData), { expires: 7, secure: true, sameSite: 'strict' });
};

export const getUserData = () => {
  const userData = localStorage.getItem('admin_user') || Cookies.get('admin_user');
  return userData ? JSON.parse(userData) : null;
};

export const clearUserData = () => {
  localStorage.removeItem('admin_user');
  Cookies.remove('admin_user');
};

// Role check functions
export const getUserRole = () => {
  const userData = getUserData();
  return userData?.role || null;
};

// Check if user has admin access (role is not 'user')
export const hasAdminAccess = () => {
  const role = getUserRole();
  return role && role !== 'user';
};

// Check if user is logged in and has valid admin token
export const isValidAdminSession = () => {
  const token = getToken();
  const userData = getUserData();
  const role = getUserRole();
  
  return token && userData && role && role !== 'user';
};